import './StandardCalendarLegend.scss';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { eventActivityType } from '../../constants/myBlockMonth';

const useStyles = makeStyles((theme) => ({
  gridItem: {
    paddingBottom: '2.4rem'
  }
}));

const StandardCalendarLegend = ({ eventList, reservePilot, noData }) => {
  const styles = useStyles();
  const { t } = useTranslation();

  const longlayer = '(23:40)';
  const shortlayer = '(13:40)';

  let pairingList = [] as any;
  eventList.length &&
    eventList.forEach((event) => {
      if (event.activityType === eventActivityType.PAIRING) {
        pairingList.push({ ...event.pairingDetails });
      }
    });

  let hotelSegmentData = [] as any;
  pairingList.length &&
    pairingList.forEach((item) => {
      item?.events?.length &&
        item?.events?.forEach((itemHotel) => {
          itemHotel?.segments?.length &&
            itemHotel?.segments?.forEach((itemSegment) => {
              itemSegment?.hotelSegment?.length &&
                itemSegment?.hotelSegment.forEach((hotelData) => {
                  if (hotelData?.hotel !== '') {
                    hotelSegmentData.push(hotelData?.hotel);
                  }
                });
            });
        });
    });

  let hotelArray = hotelSegmentData.reduce((accumalator, current) => {
    if (
      !accumalator.some(
        (item) => item.id === current.id && item.name === current.name
      )
    ) {
      accumalator.push(current);
    }
    return accumalator;
  }, []);

  return (
    <>
      <div className="standard-calendar-legend-container">
        <div className="standard-calendar-legend-detailsContainer">
          <p className="legend-title">{t(`myBlockMonth.legend`)}</p>
          <div
            className={
              reservePilot
                ? 'grid-container-reserve'
                : 'grid-container-block-holder'
            }
          >
            <p>
              <span className="pairing-standard-indicator legend-common"></span>
              {reservePilot ? (
                <span className="paring-standard">
                  {t(`myBlockMonth.reserveLegend`)}
                </span>
              ) : (
                <span className="paring-standard">
                  {t(`myBlockMonth.pairingLegend`)}
                </span>
              )}
            </p>
            {reservePilot ? (
              <>
                <p>
                  <span className="release-reserve-indicator legend-common"></span>
                  <span className="release-reserve-standard">
                    {t(`myBlockMonth.releaseLegend`)}
                  </span>
                </p>
                <p>
                  <span className="reserve-day-off-standard-indicator legend-common"></span>
                  <span className="reserve-day-off-standard">
                    {t(`myBlockMonth.reserveDayOffLegend`)}
                  </span>
                </p>
                <p>
                  <span className="displaced-standard-indicator legend-common"></span>
                  <span className="displaced-standard">
                    {t(`myBlockMonth.displacePairingLegend`)}
                  </span>
                </p>
              </>
            ) : (
              <>
                <p>
                  <span className="displaced-standard-indicator legend-common"></span>
                  <span className="displaced-standard">
                    {t(`myBlockMonth.displacePairingLegend`)}
                  </span>
                </p>
                <p>
                  <span className="reassignment-standard-indicator legend-common"></span>
                  <span className="reassignment-standard">
                    {t(`myBlockMonth.reassignmentPeriodLegend`)}
                  </span>
                </p>
              </>
            )}
            <p>
              <span className="training-standard-indicator legend-common"></span>
              <span className="training-standard">
                {t(`myBlockMonth.trainingLegend`)}
              </span>
            </p>
            <p>
              <span className="vacation-standard-indicator legend-common"></span>
              <span className="vacation-standard">
                {t(`myBlockMonth.vacationLegend`)}
              </span>
            </p>
            <p>
              <span className="sickDay-standard-indicator legend-common"></span>
              <span className="sickDay-standard">
                {t(`myBlockMonth.sickDayLegend`)}
              </span>
            </p>
            <div className="deadHead-flight">
              <div className="deadHeadFlight-standard-indicator legend-common"></div>
              <div className="legend__element__mr">=</div>
              <div className="dead-head-flight-text">
                {t(`myBlockMonth.deadHeadFlightLegend`)}
              </div>
            </div>
            <p>
              <span className="layoverDuration-standard-indicator"></span>
              <span className="layoverDuration-standard">
                {t(`myBlockMonth.layoverDurationLegend`)}
              </span>
            </p>
            <div className="long-layover">
              <div className="long-layover-content">{longlayer}</div>
              <div className="legend__element__mr">=</div>
              <div className="long-layover-text">
                {t(`myBlockMonth.longLayoverLegend`)}{' '}
              </div>
            </div>
            <div className="shortLayover-layover">
              <div className="shortLayover-content">{shortlayer}</div>
              <div className="legend__element__mr">=</div>
              <div className="shortLayover-text">
                {t(`myBlockMonth.shortLayoverLegend`)}{' '}
              </div>
            </div>
          </div>
        </div>
        <div className="hotel-info-container">
          <div className="legend-label-hotel">
            {hotelSegmentData?.length > 0 && (
              <p className="label-hotel">
                <span>{t(`myBlockMonth.hotelInfoLegend`)}</span>
              </p>
            )}
          </div>
          <Grid item lg={12} container className="legend-details-info">
            {hotelArray.map((item) => (
              <Grid className={styles.gridItem} item lg={3} xs={4}>
                <p className="info-detail info-label">{item.name}</p>
                <p className="info-detail">{item.address}</p>
                <p className="info-detail">
                  {' '}
                  {t(`myBlockMonth.phoneLegend`)}{' '}
                  <span className="phone-number">
                    <a href={`tel:${item.phone}`} className="phoneNumber">
                      {item.phone}
                    </a>
                  </span>
                </p>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </>
  );
};

export default StandardCalendarLegend;
